import React from "react";
import Offerortable from "./List/OfferorList";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import "../../../components/common/css/datatable.scss";
import "../../../components/common/css/index.scss";

const index = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Offerortable />
      </div>
    </div>
  );
};

export default index;
